import { Injectable, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarDismiss } from '@angular/material/snack-bar';

import { EpcotConfig } from '@frontend/sports/common/client-config-data-access';
import { DsToastType } from '@frontend/ui/toast';
import { Observable } from 'rxjs';

import { ToasterComponent } from './toaster.component';

export interface ToasterConfig {
    type?: DsToastType;
    duration?: number;
    panelClass?: string;
}

export interface ToasterModel {
    type: DsToastType;
    message: string;
    dismiss: () => void;
}

export interface Toaster {
    dismissed: Observable<MatSnackBarDismiss>;
    opened: Observable<void>;
    dismiss(): void;
}

@Injectable({ providedIn: 'root' })
export class ToasterService {
    private snackBar = inject(MatSnackBar);
    private epcotConfig = inject(EpcotConfig);

    private isEpcotEnabled: boolean;
    constructor() {
        this.isEpcotEnabled = this.epcotConfig.isEnabled;
    }

    open(message: string, { type, duration, panelClass }: ToasterConfig = {}): Toaster {
        const toasterPanelClass = this.isEpcotEnabled ? 'toaster-panel' : 'row-toaster-panel';
        const panelClasses = [toasterPanelClass];
        if (panelClass) {
            panelClasses.push(...panelClass.split(' '));
        }
        const toaster = this.snackBar.openFromComponent<ToasterComponent, ToasterModel>(ToasterComponent, {
            data: {
                type: type ?? 'info',
                message,
                dismiss: () => {
                    toaster.dismiss();
                },
            },
            horizontalPosition: 'left',
            verticalPosition: 'bottom',
            panelClass: panelClasses,
            duration,
        });

        return {
            dismiss: () => {
                toaster.dismiss();
            },
            dismissed: toaster.afterDismissed(),
            opened: toaster.afterOpened(),
        };
    }

    dismiss(): void {
        this.snackBar.dismiss();
    }
}
